import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=fb6df808&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=fb6df808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6df808",
  null
  
)

export default component.exports